// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2K6z4","containerItemsCenter":"Skeleton_containerItemsCenter__sU9Kl"};